module.exports = __webpack_public_path__ + "img/banner-mob.7c5655f.png";